import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const DummySearchPage = () => {
    const Navigate = useNavigate();
  const items = [
    "Ponds lotion",
    "Lakme Cream",
    "Dove soap",
    "Vaseline lotion",
    "Pears soap"
  ];
  
  const [currentItem, setCurrentItem] = useState(items[0]);
  const [isSearchVisible, setIsSearchVisible] = useState(false); // Track visibility of search bar

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentItem(prevItem => {
        const currentIndex = items.indexOf(prevItem);
        const nextIndex = (currentIndex + 1) % items.length; // Cycle through the items
        return items[nextIndex];
      });
    }, 3000); // Change every 3 seconds

    return () => clearInterval(interval); // Clean up interval on component unmount
  }, []);
   // handleClick function to toggle search bar visibility
   const handleClick = () => {
    setIsSearchVisible(prevState => !prevState); // Toggle visibility of search bar
    Navigate("/search");  
};


  return (
    <div onClick={handleClick}className='bb-1 border-list-group  mb-05 p-05 bg-css pos-sticky top-0 z-100'>
      <div  className= "bg-white" style={{borderRadius: '8px', position: 'relative', border: '2px solid var(--primary-color)', paddingLeft: '30px', padding: '0.5rem' }}>
        <span style={{ position: 'absolute', left: '10px', top: '50%', transform: 'translateY(-50%)', fontSize: '12px', color: '#aaa'}}>
          <i className="pi pi-search text-black"></i>
        </span>
        
        <span className="p-5 text-primary" style={{ marginLeft: '30px' }}>
          search '{currentItem}'
        </span>
      </div>
      
    </div>
  );
};

export default DummySearchPage;
